<template>
    <tr :class="rowClasses(row._index)" :draggable="draggable" @dragstart="onDrag($event,row._index)" @drop="onDrop($event,row._index)" @dragover="allowDrop($event)" v-if="draggable"><slot></slot></tr>
    <tr :class="rowClasses(row._index)" v-else><slot></slot></tr>
</template>
<script>
    export default {
        name: "TableTr",

        inject: ['tableRoot'],

        props: {
            row: Object,
            prefixCls: String,
            draggable: Boolean,
            sourceData: Object
        },
        computed: {
            objData () {
                return this.$parent.objData;
            }
        },
        methods: {
            onDrag (e,index) {
                e.dataTransfer.setData('index',index);
            },
            onDrop (e,index) {
                const dragIndex = e.dataTransfer.getData('index');
                this.$parent.$parent.dragAndDrop(dragIndex,index);
                e.preventDefault();
            },
            allowDrop (e) {
                e.preventDefault();
            },
            rowClasses (_index) {
                return [
                    `${this.prefixCls}-row`,
                    this.rowClsName(_index),
                    {
                        [`${this.prefixCls}-row-highlight`]: this.objData[_index] && this.objData[_index]._isHighlight,
                        [`${this.prefixCls}-row-hover`]: this.objData[_index] && this.objData[_index]._isHover
                    }
                ];
            },
            rowClsName (_index) {
                return this.$parent.$parent.rowClassName(this.objData[_index], _index);
            },
        },
        watch: {
            sourceData: {
                handler(newVal){
                    // 更新追踪状态
                    this.tableRoot.saveTrack(newVal)

                    // 将变化赋值给rebuildRow
                    Object.assign(this.row, newVal)
                    // 若克隆/对象存在，则更新
                    if(this.tableRoot.cloneData[this.row._index]){
                        Object.assign(this.tableRoot.cloneData[this.row._index], newVal)
                    }
                },
                deep: true
            }
        }
    }
</script>
